import { resizeImage } from '@mc/resize-image'

export const tileOptimizedImage = (src: string) =>
  resizeImage(src, {
    width: 395,
    height: 702,
    quality: 75,
    dpr: 1,
  })

export const nameplateOptimizedImage = (src: string) =>
  resizeImage(src, { width: 200, quality: 75, dpr: 2 })
